import { render, staticRenderFns } from "./CardOutrosDados.vue?vue&type=template&id=70baec9d&"
import script from "./CardOutrosDados.vue?vue&type=script&lang=js&"
export * from "./CardOutrosDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports